import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Home.module.css';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
          navigate('/business');
          return;
        }
      }, [navigate]);

  return (
    <div className={styles.container}>
      <img src="" alt="背景画像" className={styles.backgroundImage} />
      
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>業務自動化診断・シミュレーション</h1>
        </header>
        <div className={styles.card}>
          <button
            onClick={() => navigate('/register')}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            新規登録
          </button>
          <button
            onClick={() => navigate('/login')}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            ログイン
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
